import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { getSources, Source } from '../../api';

export interface SourcesState {
	data: Source[];
	error: boolean;
	loading: boolean;
}

export const initialState: SourcesState = {
	data: [],
	error: false,
	loading: true
};

export const fetchSources = createAsyncThunk('sources/fetchAll', getSources);

export const sourcesSlice = createSlice({
	name: 'sources',
	initialState,
	reducers: {
		sourcesAction: (state, action: PayloadAction<Partial<SourcesState>>) => {
			state = {
				...state,
				...action.payload
			};
		}
	},
	extraReducers: builder => {
		builder.addCase(fetchSources.pending, state => {
			state.data = [];
			state.error = false;
			state.loading = true;
		});

		builder.addCase(fetchSources.fulfilled, (state, action) => {
			state.data = action.payload;
			state.error = false;
			state.loading = false;
		});

		builder.addCase(fetchSources.rejected, state => {
			state.error = true;
			state.loading = false;
		});
	}
});

export const { sourcesAction } = sourcesSlice.actions;
export const sourcesReducer = sourcesSlice.reducer;
